import Lenis from 'lenis'

// Respect reduced motion
const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
let lenis;

function initLenis() {
  if (prefersReduced) return;
  lenis = new Lenis({
    duration: 1.2,
    easing: (t) => 1 - Math.pow(1 - t, 3),
    smoothWheel: true,
    smoothTouch: true
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // Handle in-page anchors (offset for sticky header)
  const header = document.querySelector('header.sticky, header.fixed');
  const headerHeight = header?.offsetHeight || 0;

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href');
    const target = document.querySelector(id);
    if (!target) return;

    e.preventDefault();
    const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
    lenis.scrollTo(top, { offset: 0 });
  });

  // Pause during modals/offcanvas if needed:
  document.addEventListener('lenis:pause', () => lenis.stop());
  document.addEventListener('lenis:resume', () => lenis.start());
}
document.addEventListener('DOMContentLoaded', initLenis);

/** Header Hamburger Menu */
document.addEventListener("DOMContentLoaded", () => {
  const toggle = document.getElementById("mobile-menu-toggle");
  const menu   = document.getElementById("mobile-menu");
  const close  = document.getElementById("mobile-menu-close");

  const openMenu = () => {
    menu.classList.remove("hidden");
    void menu.offsetWidth; // reflow
    menu.classList.remove("-translate-x-full");
    menu.classList.add("translate-x-0");
    document.body.style.overflow = "hidden";
    toggle?.setAttribute("aria-expanded", "true");
  };

  const closeMenu = () => {
    // 1) Restore scroll immediately (so we’re never stuck)
    document.body.style.overflow = "";
    toggle?.setAttribute("aria-expanded", "false");

    // 2) Animate out
    menu.classList.remove("translate-x-0");
    menu.classList.add("-translate-x-full");

    // 3) After the transform transition ends, hide the panel
    const onEnd = (e) => {
      if (e.propertyName !== "transform") return;
      menu.classList.add("hidden");
      menu.removeEventListener("transitionend", onEnd);
    };
    menu.addEventListener("transitionend", onEnd, { once: true });

    // 4) Fallback: if transitionend doesn't fire, hide after ~duration
    const dur = getComputedStyle(menu).transitionDuration
      .split(",")[0].trim(); // first duration in list
    const ms = dur.endsWith("ms") ? parseFloat(dur) : parseFloat(dur) * 1000;
    setTimeout(() => {
      if (!menu.classList.contains("hidden")) {
        menu.classList.add("hidden");
      }
    }, isNaN(ms) ? 350 : Math.max(ms + 50, 200));
  };

  toggle?.addEventListener("click", openMenu);
  close?.addEventListener("click", closeMenu);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !menu.classList.contains("hidden")) closeMenu();
  });
});

/** Dark Mode Toggle */
(function () {
  const root   = document.documentElement;
  const btn    = document.getElementById('theme-toggle');
  if (!btn) return;

  const iconLight = btn.querySelector('.dark-off'); // shows when currently LIGHT (moon icon to go dark)
  const iconDark  = btn.querySelector('.dark-on');  // shows when currently DARK (sun icon to go light)
  const mql       = window.matchMedia('(prefers-color-scheme: dark)');

  function setFromSystem() {
    const dark = mql.matches;
    root.classList.toggle('dark', dark);
    root.classList.toggle('light', !dark);
    updateButton(dark ? 'dark' : 'light');
  }

  function apply(mode) {
    if (mode === 'dark') {
      root.classList.add('dark');
      root.classList.remove('light');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      root.classList.add('light');
      localStorage.setItem('theme', 'light');
    }
    updateButton(mode);
  }

  function getCurrentMode() {
    const saved = localStorage.getItem('theme'); // "light" | "dark" | null
    if (saved === 'light' || saved === 'dark') return saved;
    return mql.matches ? 'dark' : 'light'; // system fallback for first run
  }

  function updateButton(mode) {
    // aria-pressed = true when DARK
    btn.setAttribute('aria-pressed', String(mode === 'dark'));
    // show the right icon
    if (iconLight && iconDark) {
      if (mode === 'dark') {
        iconLight.classList.add('hidden');
        iconDark.classList.remove('hidden');
      } else {
        iconLight.classList.remove('hidden');
        iconDark.classList.add('hidden');
      }
    }
  }

  // Initialize
  const initial = localStorage.getItem('theme');
  if (initial === 'light' || initial === 'dark') {
    apply(initial);
  } else {
    setFromSystem();
  }

  // If you *want* the button to follow OS when user never chose a theme:
  mql.addEventListener('change', () => {
    if (!localStorage.getItem('theme')) setFromSystem();
  });

  // Toggle on click: light <-> dark
  btn.addEventListener('click', () => {
    const mode = getCurrentMode();
    apply(mode === 'dark' ? 'light' : 'dark');
  });
})();

(function () {
  const bar = document.getElementById('scroll-progress-bar');
  if (!bar) return;

  let ticking = false;

  function setWidth() {
    const doc   = document.documentElement;
    const body  = document.body;
    const pageH = Math.max(doc.scrollHeight, body.scrollHeight);
    const viewH = window.innerHeight || doc.clientHeight;
    const max   = Math.max(pageH - viewH, 1); // avoid div by 0
    const y     = window.scrollY || doc.scrollTop || 0;
    const pct   = Math.min(Math.max((y / max) * 100, 0), 100);

    bar.style.width = pct + '%';
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(setWidth);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // initialize
  onScroll();
})();
